var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _rect, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 114,
    viewBox: "0 0 116 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 57,
    r: 57,
    fill: "#3F3E3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1869_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.638 56.9774C106.638 83.8267 84.8726 105.592 58.0233 105.592C31.1739 105.592 9.4082 83.8267 9.4082 56.9774C9.4082 30.128 31.1739 8.3623 58.0233 8.3623C84.8726 8.3623 106.638 30.128 106.638 56.9774Z",
    fill: "url(#paint0_linear_1869_282)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4316 101.22C37.4397 91.0255 42.3316 82.7656 57.9933 82.7656C73.5308 82.7656 78.4687 90.8952 78.5538 100.978C72.2475 103.986 65.188 105.67 57.7352 105.67C50.4846 105.67 43.6063 104.076 37.4316 101.22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6677 94.3826C18.6403 87.6566 12.8268 78.3752 10.4785 67.7901C16.036 66.3042 22.2577 66.1659 26.3394 67.1541C34.1516 69.0454 40.7795 76.3612 37.0102 84.3318C35.1443 88.2773 31.1949 92.0541 26.6677 94.3826Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.01 67.7274C102.68 78.2963 96.8964 87.5689 88.9027 94.3015C84.4411 91.967 80.5609 88.2319 78.7166 84.3318C74.9473 76.3612 81.5751 69.0454 89.3873 67.1541C93.4109 66.18 99.5139 66.3005 105.01 67.7274Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67551 69.4914C7.75771 68.4503 10.881 67.6695 12.1824 67.4092L11.9221 70.2722C9.8399 70.5325 8.27825 71.3133 6.71661 72.0941C5.71369 72.5956 4.20063 73.6558 3.59332 74.1763C3.59332 74.1763 3.33305 73.1352 3.07277 72.3544C2.8125 71.5736 2.8125 71.3133 2.8125 71.3133C3.24629 70.9663 3.59332 70.5325 5.67551 69.4914Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.566 69.7516C107.703 68.3201 104.84 67.6695 103.539 67.4092L104.059 70.7927C106.141 71.053 107.702 71.8336 109.264 72.6143L109.265 72.6147C110.267 73.1161 111.782 73.916 112.389 74.4366C112.389 74.4366 112.649 73.916 112.909 72.8749C113.159 71.8756 113.168 71.3559 113.169 71.3158C113.169 71.3319 113.18 71.3343 113.169 71.3139C113.169 71.3135 113.169 71.3133 113.169 71.3133C113.169 71.3135 113.169 71.3137 113.169 71.3138C113.127 71.2394 112.789 70.8629 110.566 69.7516Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 16.5933C21.204 15.9771 24.153 17.5176 24.8573 21.435C12.6209 32.703 6.67882 48.6806 10.3762 67.7833C6.78091 68.7079 4.61011 69.9401 2.8495 71.3046C-2.03629 51.8497 2.76155 31.7787 17.8148 16.5933Z",
    fill: "#FCB333",
    stroke: "#FFBB00",
    strokeWidth: 0.0880309
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1852 16.6812C94.796 16.065 91.847 17.6055 91.1427 21.5229C103.379 32.7909 109.321 48.7685 105.624 67.8712C109.219 68.7958 111.39 70.028 113.151 71.3925C118.036 51.9376 113.238 31.8666 98.1852 16.6812Z",
    fill: "#FCB333",
    stroke: "#FCB333",
    strokeWidth: 0.0880309
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2741,
    cy: 35.0218,
    r: 22.7475,
    transform: "rotate(-3.91817 60.2741 35.0218)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2741,
    cy: 35.0223,
    r: 15.448,
    transform: "rotate(-3.91817 60.2741 35.0223)",
    fill: "#434343"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.3516,
    y: 33.1895,
    width: 7.29958,
    height: 39.214,
    rx: 3.64979,
    transform: "rotate(-3.91817 37.3516 33.1895)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0794 76.6318C78.3018 86.2465 68.9363 93.0529 57.9811 93.0529C47.0259 93.0529 37.6605 86.2465 33.8828 76.6318H35.9541C39.6232 85.1627 48.1036 91.1362 57.9792 91.1362C67.8549 91.1362 76.3353 85.1627 80.0044 76.6318H82.0794Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1869_282",
    x: 9.4082,
    y: 8.3623,
    width: 97.2305,
    height: 97.4065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.176062
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0880309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1869_282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1869_282",
    x1: 39.5148,
    y1: 128.26,
    x2: 85.4669,
    y2: 13.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939393",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerLogo);
export default __webpack_public_path__ + "static/media/partner_logo.d0dbcc17aefed90297e2773ae9131971.svg";
export { ForwardRef as ReactComponent };